
import SuggestionSlider from '@/components/Search/Suggestions/SuggestionSlider.vue'
import SuggestionsTemplates from '@/components/Search/Suggestions/SuggestionsTemplates.vue'
export default {
    name: 'Suggestions',
    components: {
        SuggestionSlider,
        SuggestionsTemplates
    },
    props: {
        theme: {
            type: String,
            default: 'slider',
            validator: val => ['slider', 'templates'].includes(val)
        },
        type: {
            type: String,
            required: true,
            validate (value) {
                return ['file', 'contract_template'].includes(value)
            }
        }
    },
    computed: {
        suggestions () {
            const store = this.type + 's'
            return this.$store.state[store].suggestion
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        loadData () {
            if (this.suggestions !== null) {
                return
            }
            const store = this.type + 's'
            this.$axios.$get('/v1/categories', {
                params: {
                    type: this.type
                }
            })
                .then((res) => {
                    this.$store.commit(store + '/setSuggestion', res)
                })
                .catch((e) => {
                    this.$store.commit(store + '/setSuggestion', [])
                    throw e
                })
        }
    }
}
